import {DateTimePicker} from "@mantine/dates";
import type {Dispatch, SetStateAction} from "react";
import {useWorkspace} from "~/contexts/workspaceContext";
import {isAmaronWorkspace} from "~/domainModels/workspaceSpecific/amaron";
import {OttopilotTrigger} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/ottopilotEventContainersWorkspaceCapability/domain/OttopilotEventContainerTriggerConfig";
import type {OttopilotTriggerConfig} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/ottopilotEventContainersWorkspaceCapability/domain/OttopilotEventContainerTriggerConfig";
import {AnankeField} from "@vesta/ananke/components/anankeField";
import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {
    iso8601DateTimeUtcToTriggerSchedulePickerValue,
    resolveActiveTrigger,
    triggerSchedulePickerValueToIso8601DateTimeUtc,
} from "~/utilities/eventContainerTriggerEvent";

export function EventContainerDetailsTriggerEvent({
    triggerConfig,
    selectedDispositionId,
    triggerEvent,
    setTriggerEvent,
}: {
    triggerConfig: OttopilotTriggerConfig | undefined;
    selectedDispositionId: Uuid | null;
    triggerEvent: {additionalColumnValues: Record<Uuid, unknown>} | null;
    setTriggerEvent: Dispatch<SetStateAction<{additionalColumnValues: Record<Uuid, unknown>} | null>>;
}) {
    const {workspaceCapabilities} = useWorkspace();
    const timePickerFormat = isAmaronWorkspace(workspaceCapabilities) === true ? "24h" : "12h";

    if (triggerConfig === undefined || triggerConfig.length === 0) {
        return null;
    }
    const activeTrigger = resolveActiveTrigger(triggerConfig, selectedDispositionId);
    if (activeTrigger === undefined || activeTrigger.type !== OttopilotTrigger.dateTimeTrigger) {
        return null;
    }

    // const tempTriggerEvent: {additionalColumnValues: Record<Uuid, unknown>} = {
    //     additionalColumnValues: {
    //         [activeTrigger.dateTimeColumnId]: null,
    //     },
    // };
    // if (triggerEvent !== null) {
    //    tempTriggerEvent.additionalColumnValues = triggerEvent.additionalColumnValues;
    // }

    const label = activeTrigger.scheduleFieldLabel ?? "Schedule";

    return (
        <AnankeField
            id={activeTrigger.dateTimeColumnId}
            label={label}
            isRequired={true}
        >
            <DateTimePicker
                size="sm"
                minDate={new Date()}
                placeholder="Pick date and time"
                timePickerProps={{
                    withDropdown: true,
                    popoverProps: {withinPortal: false},
                    format: timePickerFormat,
                }}
                value={iso8601DateTimeUtcToTriggerSchedulePickerValue(triggerEvent?.additionalColumnValues[activeTrigger.dateTimeColumnId])}
                onChange={(value: Date | string | null) => {
                    const scheduleValueUtc = triggerSchedulePickerValueToIso8601DateTimeUtc(value);
                    setTriggerEvent((prev) => {
                        const syncFromDisposition: Record<Uuid, unknown> = {};
                        if (activeTrigger.syncSelectedDispositionToColumnIds !== undefined && selectedDispositionId !== null) {
                            for (const columnId of activeTrigger.syncSelectedDispositionToColumnIds) {
                                syncFromDisposition[columnId] = selectedDispositionId;
                            }
                        }
                        if (prev === null) {
                            return {
                                additionalColumnValues: {
                                    [activeTrigger.dateTimeColumnId]: scheduleValueUtc,
                                    ...syncFromDisposition,
                                },
                            };
                        }
                        return {
                            ...prev,
                            additionalColumnValues: {
                                ...prev.additionalColumnValues,
                                [activeTrigger.dateTimeColumnId]: scheduleValueUtc,
                                ...syncFromDisposition,
                            },
                        };
                    });
                }}
            />
        </AnankeField>
    );
}
